'use client';

import clsx from 'clsx';
import { useState } from 'react';

interface TabsProps {
	tabsItems: { name: string; dataNumber: number }[];
}

export const Tabs = ({ tabsItems }: TabsProps) => {
	const [activeTab, setActiveTab] = useState(0);

	return (
		<div className="flex w-full justify-between">
			{tabsItems.map((tab, index) => (
				<div
					key={index}
					onClick={() => setActiveTab(index)}
					className={clsx('flex cursor-pointer items-center gap-2 border-b-2 px-6 pb-2 ', {
						'border-brand-600 text-brand-600': index === activeTab,
						'border-transparent text-gray-500': index !== activeTab
					})}
				>
					<span className="text-base text-sm font-bold">{tab.name}</span>
					{tab.dataNumber > 0 && <div className="rounded-full bg-gray-100 px-2 text-sm text-gray-600">{tab.dataNumber}</div>}
				</div>
			))}
		</div>
	);
};

export const TestTabs = () => {
	return (
		<div>
			<Tabs
				tabsItems={[
					{ dataNumber: 5, name: 'Active teams' },
					{ dataNumber: 0, name: 'Player activity' },
					{ dataNumber: 0, name: 'Schedule' }
				]}
			/>
		</div>
	);
};
